module.exports = __webpack_public_path__ + "img/halloween_balloons.e4ed11ef.svg";